// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store';
import App from './App'
import router from './router'
import { appRouter } from './router';
import * as Cache from './cache/Cache';
import Util from './libs/util';
import Vue2OrgTree from 'vue2-org-tree';
import EVueContextmenu from 'e-vue-contextmenu'
import { directive as clickOutside } from 'v-click-outside-x'
import OrgTree from 'v-org-tree'
import 'v-org-tree/dist/v-org-tree.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import BaiduMap from 'vue-baidu-map';
Vue.use(BaiduMap, {
  /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
  ak: 'D5paAxV41sELOtnFjFQEaT3VbLRR2OA4'
})
import './styles/sign.css';

import iView from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(iView);

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import BasicTable from './components/BasicTable';
import SearchForm from './components/SearchForm';
import UploadView from './components/Upload';
import TinymceEditor from './components/tinymce/Tinymce.vue'
import SignCalendar from './pages/components/signCalendar.vue'
Vue.component('SignCalendar', SignCalendar)
Vue.component('Editor', TinymceEditor)
Vue.component('BasicTable', BasicTable)
Vue.component('SearchForm', SearchForm)
Vue.component('UploadView', UploadView)


Vue.use(OrgTree)

Vue.directive('clickOutside', clickOutside)

Vue.use(EVueContextmenu)
Vue.use(Vue2OrgTree)
Vue.config.productionTip = false
//设置全局router 可以直接使用this.router.push()跳转
Vue.prototype.router = router
//EventBus事件总线
Vue.prototype.eventBus = new Vue();


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted() {
    this.currentPageName = this.$route.name;
    // 显示打开的页面的列表
    this.$store.commit('setOpenedList');
    this.$store.commit('initCachepage');
    // 权限菜单过滤相关
    this.$store.commit('updateMenulist');
  },
  created() {
    global.vm = this;
    let tagsList = [];
    appRouter.map((item) => {
      if (item.children.length <= 1) {
        tagsList.push(item.children[0]);
      } else {
        tagsList.push(...item.children);
      }
    });
    this.$store.commit('setTagsList', tagsList);
  },

})

/**全局自定义指令*/

//按钮权限的指令
Vue.directive('permission', {
  inserted: function (el, binding) {
    let permissionInfo = Cache.getPermissions();
    let permissions = permissionInfo ? permissionInfo : [];
    let permissionId = binding.value;
    if (!Util.isHavePermission(permissionId, permissions)) {
      el.parentNode.removeChild(el);
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js